import { Component, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { QuotationVersionModel } from 'src/app/models/preliminaries/quotation-version.model';
import { QuotationVersionService } from 'src/app/services/preliminaries/quotation-version.service';

@Component({
  selector: 'app-print-version',
  templateUrl: './print-version.component.html',
  styleUrls: ['./print-version.component.scss'],
  standalone: false
})
export class PrintVersionComponent implements OnInit {

  listVersions: any[] = [];
  selectedVersionContract: QuotationVersionModel = new QuotationVersionModel();
  public formPrintQuotation: FormGroup = new FormGroup({});
  subscription: Subscription;

  constructor(private formBuilder: FormBuilder,
    public config: DynamicDialogConfig,
    private quotationVersionService: QuotationVersionService,
    @Optional() private ref: DynamicDialogRef) { }

  ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }

    this.subscription = input$?.subscribe((inputs: any) => {
      this.selectedVersionContract = inputs.selectedVersionContract;
      this.listVersions = inputs.listVersions;
      this.validateForm(this.selectedVersionContract);
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  async getVersionSelect(versionId: number) {
    const previousQuotationVersionId = this.selectedVersionContract.quotationVersionId;
    if (previousQuotationVersionId === versionId) {
      return;
    }

    if (versionId) {
      this.formPrintQuotation.controls["quotationVersionId"].patchValue(versionId);
      this.selectedVersionContract = await firstValueFrom(this.quotationVersionService.getQuotationVersionById(versionId));
    } else {
      this.formPrintQuotation.controls["quotationVersionId"].patchValue(null);
    }
  }

  printVersion() {
    const output$ = this.config.data?.output$;
    const versionPrint = {
      quotationVersionId: this.selectedVersionContract.quotationVersionId,
      swBreakdown: this.formPrintQuotation.get("swBreakdown")?.value
    }
    output$?.next({ type: 'printQuotation', payload: versionPrint });
    if (this.ref) this.ref.close();
  }


  validateForm(version: QuotationVersionModel) {
    this.formPrintQuotation = this.formBuilder.group({
      quotationVersionId: [version.quotationVersionId, []],
      swBreakdown: [false, []]
    })
  }
}